/** «Рассылки» → «Отзыв о примерке» — ровно то, что отдаёт `GET /api/mailing/fitting`. */
import { apiFetch, query } from "@/lib/api";

export type FittingChannel = "telegram" | "max" | "vk" | "avito" | "instagram" | "whatsapp";

/** Отправлено и оценки кнопками; оценка относится ко дню своей рассылки. */
export type FittingCounts = { sent: number; good: number; bad: number };

export type FittingDay = {
  day: string;
  /** Только каналы, куда в этот день что-то ушло. */
  channels: Partial<Record<FittingChannel, FittingCounts>>;
  total: FittingCounts;
};

export type MailingFitting = {
  from: string;
  to: string;
  /** Все каналы в порядке выбора: бесплатные, последним — WhatsApp. */
  channels: FittingChannel[];
  /** Дни с отправками, свежие сверху. */
  days: FittingDay[];
  total: { channels: Record<FittingChannel, FittingCounts>; all: FittingCounts; free: number; paid: number };
};

export function loadMailingFitting(from: string, to: string): Promise<MailingFitting> {
  return apiFetch<MailingFitting>(`/api/mailing/fitting${query({ from, to })}`);
}
